const invoices = {
	buttons: {
		update_concept_invoices: "Update Draft Invoices",
	},
	overview: "Invoices overview",
	payment_status: {
		credit: "Credit",
		expired: "Expired",
		outstanding: "Outstanding",
		paid: "Paid",
		partly_paid: "partly paid",
	},
	status_invoices_update_success: "Draft invoices updated successfully",
	status_invoices_update_unknown: "Something went wrong when updating Draft Invoices",
	table: {
		amount: "Amount",
		company_name: "Company",
		date: "Date",
		debtor_code: "Debtor Code",
		id: "Invoice Number",
		status: "Status",
	},
	title: "Invoices",
	update_invoices_dialog: {
		description: "Do you want to update the draft invoices?",
		title: "Update Draft Invoices",
		update: "Update",
	},
};

export default invoices;
